module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "leipzigcastle.17155931.png";